/*
 * Validate-profile.ts
 * Description: Includes the declaration of a function
 * to validate user date before updating the profile
 */

// Importing variables
import {
    InvalidEmail, EmailRegex, MissingEmail,
    MissingFirstName, MissingLastName, MissingPassword,
    MissingPasswordConf, MissingPhone, PasswordBelowMin,
    PasswordLength, PasswordsMismatch, PhoneInvalid,
    PhoneRegex, TooLongEmail, TooLongFirstName,
    TooLongLastName, TooLongPhone,
} from '../variables';

// Declaring user data interface
export interface Profile {
    first_name: string;
    last_name: string;
    phone: string;
    email: string;
    password: string;
    old_password: string;
    password_confirmation: string;
}

/**
 * Checking if user data is valid before sending the request
 *
 * @param {String[]} errors - register errors
 * @param {Profile} data - user data
 */
export function validateProfile(errors: string[], data: Profile) {
    // Validating first name
    if (data.first_name.length === 0) { errors.push(MissingFirstName); }
    if (data.first_name.length > 255) { errors.push(TooLongFirstName); }

    // Validating last name
    if (data.last_name.length === 0) { errors.push(MissingLastName); }
    if (data.last_name.length > 255) { errors.push(TooLongLastName); }

    // Validating email
    if (data.email.length === 0) { errors.push(MissingEmail); }
    if (data.email.length > 255) { errors.push(TooLongEmail); }
    if (!EmailRegex.test(data.email)) { errors.push(InvalidEmail); }

    // Validating phone
    if (data.phone.length === 0) { errors.push(MissingPhone); }
    if (!PhoneRegex.test(data.phone)) { errors.push(PhoneInvalid); }
    if (data.phone.length > 255) { errors.push(TooLongPhone); }

    // Validating the old password
    if (data.old_password.length === 0) { errors.push(MissingPassword); }
    if (data.old_password.length < PasswordLength) { errors.push(PasswordBelowMin); }
    // Validating the new password
    if (data.password.length > 0) {
        if (data.password.length < PasswordLength) { errors.push(PasswordBelowMin); }
        // Validating repeated password
        if (data.password_confirmation.length === 0) { errors.push(MissingPasswordConf); }
        if (data.password !== data.password_confirmation) { errors.push(PasswordsMismatch); }
    }
}
